import Stack from '@mui/material/Stack'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Typography from '@components/_mui/Typography'

export default function TableEmpty({ title = 'No data to display', columns, action }) {
  return (
    <TableRow sx={{ height: 100 }}>
      <TableCell colSpan={columns}>
        <Stack direction="row" spacing={1} sx={{ justifyContent: 'center' }}>
          <Typography variant="h4" sx={{ fontWeight: 'normal', color: 'text.secondary' }}>
            {title}
          </Typography>
          {action}
        </Stack>
      </TableCell>
    </TableRow>
  )
}
